import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'anomaly-detection',
  templateUrl: './anomaly-detection.component.html',
  styleUrls: ['./anomaly-detection.component.css']
})
export class AnomalyDetectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
